import { Plus } from "@phosphor-icons/react";
import ContactInput from "./ContactInput";

export const emptyContactRow = () => ({ country_code: "91", contact: "" });

const ContactListInput = ({ name, rows, onChange, errors = [] }) => {
    // A manager with no number on file still needs one empty row to type into.
    const list = rows?.length ? rows : [emptyContactRow()];

    const updateRow = (index, changes) =>
        onChange(
            list.map((row, i) => (i === index ? { ...row, ...changes } : row))
        );

    return (
        <div className="input-group border-b-[1.5px] pt-3 pb-8 min-h-[146px]">
            <label className="block text-sm">{name}</label>
            <div className="flex flex-col gap-2 mt-1">
                {list.map((row, index) => (
                    <ContactInput
                        key={index}
                        value={row.contact}
                        countryCode={row.country_code}
                        onCountryCodeChange={(code) =>
                            updateRow(index, { country_code: code })
                        }
                        onChange={(value) => updateRow(index, { contact: value })}
                        onRemove={
                            list.length > 1
                                ? () =>
                                      onChange(
                                          list.filter((_, i) => i !== index)
                                      )
                                : undefined
                        }
                        error={errors[index]}
                        wrapperClassName=""
                    />
                ))}
            </div>
            <button
                type="button"
                onClick={() => onChange([...list, emptyContactRow()])}
                className="flex items-center gap-1 text-[#0B22B2] text-sm font-semibold border-[1.5px] border-dashed border-[#0B22B2] rounded-md px-2 py-1.5 w-[95%] justify-center mt-2"
            >
                <Plus size={14} weight="bold" />
                Add another number
            </button>
        </div>
    );
};

export default ContactListInput;
